<template>
  <v-dialog
    :model-value="modelValue"
    @update:model-value="toggleDialog"
    max-width="960px"
    max-height="85vh"
    :scroll-strategy="'none'"
    :close-on-content-click="false"
    persistent
  >
    <v-card class="edit-query-card">
      <v-card-item class="px-4 py-2">
        <span class="edit-query-title">Edit Query</span>
        <v-btn
          icon="mdi-close"
          variant="plain"
          class="ml-auto"
          @click="toggleDialog(false)"
        />
      </v-card-item>
      <v-card-text v-if="schema" class="px-10 pt-4 edit-query-body">
        <query-table :schema="schema" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup>
import QueryTable from '@/components/QueryTable.vue'

const { modelValue, schema } = defineProps({
  modelValue: Boolean,
  schema: Object
})
const emit = defineEmits(['update:modelValue'])

const toggleDialog = (value) => {
  emit('update:modelValue', value)
}
</script>

<style scoped>
.v-card {
  border: 1px solid var(--dark-2);
}

.edit-query-card {
  display: flex;
  flex-direction: column;
  max-height: 85vh;
  overflow: hidden;
}

.edit-query-body {
  flex: 1 1 auto;
  overflow-y: auto;
}

:deep(.v-card-item__content) {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 10px;

  .edit-query-title {
    font-size: 20px;
    color: var(--text-light) !important;
  }
}
</style>
